<div class="modal-advanced-search">
    <div class="mdl-header d-flex align-items-center justify-content-between">
        <div>
            <h6>Search Transactions By {{ data?.title }}</h6>
            <p class="mdl-header-text">Fill in the receiver details to search transactions</p>
        </div>
        <div class="close-mdl">
            <mat-icon fontIcon="close" (click)="onClose()" />
        </div>
    </div>
    <div class="mdl-body">
        <div class="field d-flex flex-row align-items-center">
            <p class="w-40 field-label">Mobile number</p>
            <div class="w-60 field-value d-flex">
                <app-value-field [editMode]="true" class="flex-grow-1">
                    <app-value-field-input
                        *ngIf="advancedSearchForm.controls.mobile"
                        [controlDisplayName]="'Mobile number'"
                        [control]="advancedSearchForm.controls.mobile"
                        appValueField="editField"
                    />
                </app-value-field>
                <button
                    *ngIf="advancedSearchForm.controls['mobile']?.value"
                    (click)="clearControl(advancedSearchForm.controls.mobile)"
                    class="m-0 p-0 d-flex justify-content-center align-items-center rounded-circle modal-advanced-search-clear"
                    mat-ripple
                >
                    <mat-icon class="advance-search-section-clear-icon" fontIcon="close" />
                </button>
            </div>
        </div>
        <div class="field d-flex flex-row align-items-center">
            <p class="w-40 field-label">Email</p>
            <div class="w-60 field-value d-flex">
                <app-value-field [editMode]="true" class="flex-grow-1">
                    <app-value-field-input
                        *ngIf="advancedSearchForm.controls.email"
                        [controlDisplayName]="'Email'"
                        [control]="advancedSearchForm.controls.email"
                        appValueField="editField"
                    />
                </app-value-field>
                <button
                    *ngIf="advancedSearchForm.controls['email']?.value"
                    (click)="clearControl(advancedSearchForm.controls.email)"
                    class="m-0 p-0 d-flex justify-content-center align-items-center rounded-circle modal-advanced-search-clear"
                    mat-ripple
                >
                    <mat-icon class="advance-search-section-clear-icon" fontIcon="close" />
                </button>
            </div>
        </div>
    </div>
    <div class="mdl-footer">
        <button mat-flat-button class="flat-btn" (click)="onClose()">Close</button>
        <button mat-raised-button class="save-btn" [disabled]="advancedSearchForm?.invalid" (click)="dialogRef.close(advancedSearchForm.value)">Apply</button>
    </div>
</div>
